import React from 'react';

export const LocationText = () => {
  return (
    <p>
      Використовують для поліпшення умов просторової орієнтації працівників і забезпечення ефективного евакуювання людей
      із приміщень.
    </p>
  );
};
